export default {
  message: {
    hello: '你好',
    about: '关于',
    welcome: '欢迎'
  },
  cart: {
    account: '结算'
  },
  tips: {
    cart_success: "已成功加入购物车",
    add_success: "添加成功",
    empty: "空空如也~",
    order_success: "恭喜你，订单提交成功",
    chose: "请选择",
    un_pay_on_line: "暂不支持在线支付",
    area_not_empty: "地址不能为空",
    name_not_empty: "姓名不能为空",
    address_not_empty: "地址不能为空",
    phone_not_empty: "手机号不正确"
  },
  detail: {
    carriage: '运费',
    surplus: '剩余',
    CloseOrder:'完成订单',
    goods_detail: '商品详情',
    cart: '购物车',
    add_cart: '加入购物车',
    mange:'管理',
    buy_now: '立即购买',
    Subtotal:'小计',
    Total:'合计',
    jian:'件',
    Delivery_method:'送货方式',
    paypaly_method:'付款方式',
    paypaly1:'貨到货到付款付款',
    paypaly2:'支付',
    paypalyOut:'开发中,请耐心等待'
  },
  order: {
    freeFreight:'已免运费',
    allTotal:'商品总价',
    query:'订单查询',
    goods_info: '商品信息',
    pay_way: '付款方式',
    offline: '货到付款',
    online: '在线支付',
    pick_info: '收件信息',
    name_name: '姓名',
    name: '收件人姓名',
    phone_name: '电话',
    phone: '收件人手机号',
    area: '省、市、区等',
    region: '地区',
    address_name: '详细地址',
    address: '街道门牌，楼层房间号等信息',
    offer_order: '提交订单',
  },
  data: {
    Recipient_name:'收件人姓名',
    Recipient_nameTips:'请填写收件人的真实姓名，以确保顺利收到',
    Select_M:'选择门市',
    email:"收件人邮箱",
    Select_M_number:'商店名称',
    Selected_store_name:'选择商店名称',
    Shop_address:'店铺地址',
    address:'请选择地址',
    Choose_payment_method:'选择的付款方式',
    default_address:'台湾',
  },
  indexdata:{
    index:'主页',
    list:'列表',
    placeholder:'输入搜索关键字',
    Return:'返回'
  },
  Product_details_page: {
    guarantee:'保障',
    guarantee_texts: 'Genuine guarantee, fake one compensation, four fast refund',
    numbertext:'数量',
    Select_product_specification:'选择商品规格',
    Package_selection: '套餐选择',
    Buy_now: '立即购买'
  },
  newOrder:{
    Order_information:'订单信息',
    Selection_of_delivery_and_payment_methods:'选择送货方式和付款方式',
    Delivery_place:'收货地址',
    tw:'台湾',
    Delivery_method:'配送方式',
    Sub_total:'小计',
    Freight_charges:'货物',
    Total:'总计',
    Go_to_checkout:'前往结算',
  },
  order3: {
    Total:'合计  NT$',
    Delivery_information:'送货资料',
    Freight_charges:'货物',
    change:'更改',
    Search_shop:'选择门市',
    Order_notes:'订单备注',
    Payment_information:'付款资料',
    Payment_method_selected:'已选择的付款方式',
    Submit_order: '提交订单',
    xxdz:'请输入详细地址',
    Select_address: '选择地址',
    Tell_the_seller:'有什么想告诉卖家吗？',
    freight:"运费:",
    Spesifikasi_jualan_pendek:"该规格已售空"
  },
  index:{
    placeholder:'请输入搜索关键词',
    index:'首页',
    list: '列表',
    language:'选择语言'
  },
  Guarantee:{
    num:'數量',
    Pickup_method:'支持7-11、全家超商取貨',
    Guarantee:'品質保證',
    Freight:'免运费',
    Commodity_pic:'商品圖',
    Options:'選項',
    selected:'已選',
    Total_price:'訂單總價',
    Finally_cope:'最終應付',
    message:'留言',
    region:'县/市',
    region_s:'镇/乡/区',
    country:'国家/地区'
  },
  Pay:{
    language:'货到付款',
    money:'￥',
    to:'秒后跳转到首页',
    postcode:'邮编',
    setMeal:'组合套餐价',
    success:'下单成功!',
    time:'10分钟内商家会自动确认您的订单!',
    realMoney:'付款金额',
    orderNumber:'订单编号',
    waitFor:'商家未发货，请耐心等待！'
  },
  comment:{
    comment:'发表评论',
    Praise:'好评',
    Average:'中评',
    Badreview:'差评',
    submitcomments:'提交评论',
    PleaseEnteraComment:'请输入评论'
  },
  Toast:{
    inputName:'请输入姓名',
    inputPhone:'请输入手机号',
    inputZip:'请输入邮编',
    inputAddress:'请输入详细地址',
    inputAlertAddress:'该地址不配送，请换其他地址',
  },
  contactUs:{
    callMe:'咨询我们,您可联系 → Messenger',
    afterShop:'已經购物,您可联系→Email: service325@hotmail.com',
    confirm:'确认',
    shortSale:'该规格已售空',
  },
  ensure:{
    introduce:'商品介紹',
    Specifications:'商品规格',
    ensure:'商品保证',
    di:'第',
    commodity:'件商品'
  },
  wuliu:{
    orderSearch:'订单查询',
    provide:'本數據由物流官方提供',
    OrderOrLogistics:'訂單號/物流單號(填寫一項即可查詢)',
    orderPlaceho:'填寫相關訊息查詢',
    query:'查询订单号',
    Tips:'温馨提示',
    Tipsinfo:'收到商品後有任何疑問請聯繫在線客服或發郵件至service325@hotmail.com。同時請告知您的姓名/聯繫方式/訂單編號，我們會快速的給您及時處理，祝您購物愉快！',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js